import getStore from '../store/store';
import { ClientItemId } from 'owa-client-ids';
import { TimePanelSource } from 'owa-time-panel-bootstrap';

export function isPanelOpen(): boolean {
    return getStore().isPanelOpen;
}

export function getTimePanelSource(): TimePanelSource {
    return getStore().source;
}

export function getSelectedCalendarItemId(): ClientItemId {
    return getStore().selectedCalendarItemId;
}
